// extracted by mini-css-extract-plugin
module.exports = {"close":"close__3Oriz"};